export default {
    isBj: state => state.userInfo && (state.userInfo.industryId == data_source_100003973.BJ_INDUSTRY), //是否白酒行业
}


// WEBPACK FOOTER //
// ./src/store/getter.js